export const inputsInState = ['thirdId', 'thirdName', 'thirdEmail'];

export const makeInitialState = () => {
  const initialState = {
    thirdId: {
      value: '',
      error: false,
      message: '',
      helper: 'Sin puntos, pero con guión',
      inputAdornment: '',
      label: 'Rut de quien retira',
      required: true,
      success: false,
    },
    thirdName: {
      value: '',
      error: false,
      message: '',
      helper: '',
      inputAdornment: '',
      label: 'Nombre completo de quien retira',
      required: true,
      success: false,
    },
    thirdEmail: {
      value: '',
      error: false,
      message: '',
      helper: '',
      inputAdornment: '',
      label: 'Correo de quien retira',
      required: true,
      success: false,
    },
  };
  return initialState;
};
